import { boolean, intersect, literal, partial, string, struct, union } from 'io-ts/Decoder';

export const Request = intersect(
	union(
		intersect(
			struct({
				title: string,
				message: string,
				details: string,
			})
		)(
			partial({
				persistent: boolean,
				toast: boolean,
				subType: union(literal('new-version-available')),
			})
		)
	)
)(
	partial({
		broadcast: boolean,
	})
);
